import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface DayOfMonthPickerProps {
    selectedDays: number[];
    onChange: (days: number[]) => void;
    disabled?: boolean;
}

const DayOfMonthPicker = ({
    selectedDays,
    onChange,
    disabled = false,
}: DayOfMonthPickerProps) => {
    const { t } = useTranslation();

    const handleDayToggle = (day: number) => {
        if (selectedDays.includes(day)) {
            onChange(selectedDays.filter((d) => d !== day));
        } else {
            onChange([...selectedDays, day].sort((a, b) => a - b));
        }
    };

    const days = Array.from({ length: 31 }, (_, i) => i + 1);

    return (
        <Box>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                {t('settings.inventoryReminder.daysOfMonth.label')}
            </Typography>
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(7, 1fr)',
                    gap: 0.5,
                }}
            >
                {days.map((day) => (
                    <FormControlLabel
                        key={day}
                        control={
                            <Checkbox
                                checked={selectedDays.includes(day)}
                                onChange={() => handleDayToggle(day)}
                                disabled={disabled}
                                size="small"
                            />
                        }
                        label={day.toString()}
                        sx={{
                            m: 0,
                            '& .MuiFormControlLabel-label': {
                                fontSize: '0.875rem',
                            },
                        }}
                    />
                ))}
            </Box>
        </Box>
    );
};

export default DayOfMonthPicker;
